import React, {memo} from 'react';
import {IconType} from 'react-icons';
import {NamedProps} from 'react-select/src/Select';
import {UiDropdown} from '~/components/elements';
import {OPTION_ALL, OPTION_ALL_UNIQ_VALUE} from '~/hooks/useDropdown';

interface Props {
  onChange: NamedProps['onChange'];
  includeAll?: boolean;
  defaultItem?: {label: string; value: any};
  options: {label: string; value: any}[];
  selectedFontWeight?: string;
  icon?: IconType;
  styles?: React.CSSProperties;
  styleControl?: React.CSSProperties;

  [key: string]: any;
}

const CustomDropdown = ({
  includeAll = false,
  onChange,
  defaultItem,
  options,
  selectedFontWeight,
  icon,
  styles,
  styleControl,
  ...rest
}: Props) => {
  const defaultValue = {
    label: defaultItem?.label,
    value: defaultItem?.value,
  };
  if (includeAll) {
    options.unshift(OPTION_ALL);
  }

  const onChangeLocal: NamedProps['onChange'] = (value, action) => {
    if (!onChange) {
      return null;
    }
    if (value?.value === OPTION_ALL_UNIQ_VALUE) {
      onChange({value: '', label: 'All'}, action);
    } else {
      onChange(value, action);
    }
  };

  return (
    <UiDropdown
      defaultValue={includeAll ? OPTION_ALL : defaultValue}
      options={options}
      selection
      onChange={onChangeLocal}
      styles={{...styles, minWidth: '7em'}}
      styleControl={{...styleControl}}
      selectedFontWeight={selectedFontWeight}
      icon={icon}
      {...rest}
    />
  );
};

export default memo(CustomDropdown);
